import daSha from './index'
import daShaHome from './Home'

const dataHistory = () => import('./../../components/DataHistory')
const gasClamp = () => import('./gasClamp')
const bridgeImg = () => import('./bridgeImg')
const login = () => import('./login.vue')
const prepStation = () => import('./prepStation.vue')
const dehumidifier = () => import('./dehumidifier.vue')
const highPressureFan = () => import('./highPressureFan.vue')
const highPressureFanLess = () => import('./highPressureFanLess.vue')
const anchorAfan = () => import('./anchorAfan.vue')
const prepStationBig = () => import('./prepStationBig.vue')

export default [
  {
    path: '/daShaIndex',
    name: 'daShaIndex',
    component: daShaHome
  },
  {
    path: '/daSha/login',
    name: 'daShaLogin',
    component: login
  },
  {
    path: '/daSha',
    name: 'daSha',
    redirect: '/daSha/gasClamp',
    component: daSha,
    children: [
      {
        path: 'prepStation1',
        name: 'dasha_prepStation1',
        redirect: '/daSha/prepStation1/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'dasha_prepStation1_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'dasha_prepStation1_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'dehumidifierTwo',
            name: 'dasha_prepStation1_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation2',
        name: 'dasha_prepStation2',
        redirect: '/daSha/prepStation2/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'dasha_prepStation2_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'dasha_prepStation2_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'dehumidifierTwo',
            name: 'dasha_prepStation2_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation3',
        name: 'dasha_prepStation3',
        redirect: '/daSha/prepStation3/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'dasha_prepStation3_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'dasha_prepStation3_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'highPressureFanLess',
            name: 'dasha_prepStation3_highPressureFanLess',
            component: highPressureFanLess
          },
          {
            path: 'dehumidifierTwo',
            name: 'dasha_prepStation3_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation4',
        name: 'dasha_prepStation4',
        redirect: '/daSha/prepStation4/anchorAfan',
        component: prepStation,
        children: [
          {
            path: 'dehumidifierOne',
            name: 'dasha_prepStation4_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'anchorAfan',
            name: 'dasha_prepStation4_anchorAfan',
            component: anchorAfan
          },
          {
            path: 'highPressureFanLess',
            name: 'dasha_prepStation4_highPressureFanLess',
            component: highPressureFanLess
          },
          {
            path: 'dehumidifierTwo',
            name: 'dasha_prepStation4_dehumidifierTwo',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation5',
        name: 'dasha_prepStation5',
        redirect: '/daSha/prepStation5/prepStationBig',
        component: prepStation,
        children: [
          {
            path: 'prepStationBig',
            name: 'dasha_prepStation5_prepStationBig',
            component: prepStationBig
          },
          {
            path: 'highPressureFan12',
            name: 'dasha_prepStation5_highPressureFan12',
            component: highPressureFan
          },
          {
            path: 'highPressureFan34',
            name: 'dasha_prepStation5_highPressureFan34',
            component: highPressureFan
          },
          {
            path: 'dehumidifierOne',
            name: 'dasha_prepStation5_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'dehumidifierTwo',
            name: 'dasha_prepStation5_dehumidifierTwo',
            component: dehumidifier
          },
          {
            path: 'dehumidifierThree',
            name: 'dasha_prepStation5_dehumidifierThree',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'prepStation6',
        name: 'dasha_prepStation6',
        redirect: '/daSha/prepStation6/prepStationBig',
        component: prepStation,
        children: [
          {
            path: 'prepStationBig',
            name: 'dasha_prepStation6_prepStationBig',
            component: prepStationBig
          },
          {
            path: 'highPressureFan12',
            name: 'dasha_prepStation6_highPressureFan12',
            component: highPressureFan
          },
          {
            path: 'highPressureFan34',
            name: 'dasha_prepStation6_highPressureFan34',
            component: highPressureFan
          },
          {
            path: 'highPressureFan',
            name: 'dasha_prepStation6_highPressureFan',
            component: highPressureFan
          },
          {
            path: 'dehumidifierOne',
            name: 'dasha_prepStation6_dehumidifierOne',
            component: dehumidifier
          },
          {
            path: 'dehumidifierTwo',
            name: 'dasha_prepStation6_dehumidifierTwo',
            component: dehumidifier
          },
          {
            path: 'dehumidifierThree',
            name: 'dasha_prepStation6_dehumidifierThree',
            component: dehumidifier
          }
        ]
      },
      {
        path: 'bridgeImg',
        name: 'dasha__bridgeImg',
        component: bridgeImg
      },
      {
        path: 'dataHistory',
        name: 'dasha__DataHistory',
        component: dataHistory
      },
      {
        path: 'gasClamp',
        name: 'dasha__gasClamp',
        component: gasClamp
      }
    ]
  }
]
